/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ products: NonNullable<unknown> }} Lifecycle_Impact_ProductsInputs */

const en_lifecycle_impact_products = /** @type {(inputs: Lifecycle_Impact_ProductsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Products: ${i?.products}`)
};

const de_lifecycle_impact_products = /** @type {(inputs: Lifecycle_Impact_ProductsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Produkte: ${i?.products}`)
};

/**
* | output |
* | --- |
* | "Products: {products}" |
*
* @param {Lifecycle_Impact_ProductsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_impact_products = /** @type {((inputs: Lifecycle_Impact_ProductsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Impact_ProductsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_impact_products(inputs)
	return en_lifecycle_impact_products(inputs)
});